<template>
  <main class="main" id="main">
    <div class="about__text-block">
      <div class="container">
        <div class="text-block__bottom">
          <div class="text-block__text-wrapper text-block__bottom-bottom">
            <h1 style="margin-top:2%;">Оферта на оказание услуг «Хочу-поесть.рф»</h1>
            <p class="text-block__text"><br></p>
            <p>
              <br>Настоящим Общество с ограниченной ответственностью "Франшиз девелопмент рус" в лице генерального директора Шельмина Евгения Васильевича, действующего на основании Устава, осуществляющее деятельность под фирменным наименованием «Хочу-поесть.рф», владеющее сервисом www.хочу-поесть.рф, именуемое в дальнейшем «Сервис» предлагает любому лицу,  в дальнейшем именуемому «Служба Доставки» использовать с целью расширения сбыта продукции, увеличения клиентской базы Службы доставки. Служба Доставки поручает, а Сервис принимают все меры, направленные на повышение количества заказов Службы Доставки: предоставление Службе Доставки размещения информации на интернет-ресурсе www.хочу-поесть.рф, его рекламы с целью получения Службой Доставки заказов от Потребителей. Служба доставки оплачивает вознаграждение за каждый заказ Потребителя.
            </p>
            <p>
              <br>Настоящие условия оказания услуг оказываются в соответствии с п. 2 ст. 437 Гражданского кодекса РФ является Публичной офертой. Полным и безоговорочным принятием (акцептом) Условий в соответствии со ст. 438 Гражданского кодекса РФ является совершение «Службой доставки» действий по подключению к интернет-ресурсе www.хочу-поесть.рф.
            </p>
            <p>
              <br>Термины и определения:
            </p>
            <p>
              <br>- «Сервис» - ООО «Франшиз девелопмент рус» в лице генерального директора Шельмина Е.В.,
            </p>
            <p>
              <br>- Акцепт - полное и безоговорочное принятие «Службой Доставки» настоящей Оферты. Во избежание любого рода недоразумений, совершив Акцепт, Покупатель подтверждает, что:  он целиком и полностью ознакомлен с условиями настоящей Оферты.
            </p>
            <p>
              <br>- Совокупность информационных ресурсов, размещённых в Интернете по адресу  www.хочу-поесть.рф
            </p>
            <p>
              <br>1.Предмет Публичной Оферты
            </p>
            <p>
              <br>1.1. Предметом договора является сотрудничество Сторон на условиях Оферты с целью расширения сбыта продукции, увеличения клиентской базы Службы доставки. Служба Доставки поручает, а Сервис принимают все меры, направленные на повышение количества заказов Службы Доставки: предоставление Службе Доставки размещения информации на интернет-ресурсе www.хочу-поесть.рф, его рекламы с целью получения Службой Доставки заказов от Потребителей. Служба доставки оплачивает вознаграждение за каждый заказ Потребителя.
            </p>
            <p>
              <br>Служба Доставки имеет фирменное (ые) наименование (я), расположенное(ые) по адресу (ам)
            </p>
            <p>
              <br>1.1.1. Наименование, город, адрес(а) _____________________________________.
            </p>
            <p>
              <br>2.Обязательства сторон
            </p>
            <p>
              <br>2.1 Сервис обязуется:
            </p>
            <p>
              <br>2.1.1 Предпринимать все усилия для продвижения продукции Службы Доставки, Самостоятельно и за свой счет рекламировать представленную Службой Доставки продукцию.
            </p>
            <p>
              <br>2.1.2 Предоставить Службе Доставки доступ в личный кабинет.
            </p>
            <p>
              <br>2.2. Служба Доставки обязуется:
            </p>
            <p>
              <br>2.2.1 Заполнить меню в личном кабинете или поручить это выполнить Сервису
            </p>
            <p>
              <br>2.2.2 Обработать поступивший заказ (заявку) в течение 15 (пятнадцать) минут после его поступления – о его поступлении Служба Доставки уведомляется посредством смс на указанный в личном кабинете номер телефона, e-mail указанную в личном кабинете, а также непосредственно в личном кабинете. В случае непринятия заказа в течение 30 минут с момента поступления, Заказ автоматически отменяется. Служба доставки выплачивает Сервису вознаграждение в размере 10 % от суммы заказа, если Заказ не принят по вине Службы доставки.
            </p>
            <p>
              <br>2.2.3 При поступлении заказа, требующего корректировки в том числе при изменении состава заказа и его окончательной стоимости скорректировать заказ в личном кабинете в момент принятия заказа.
            </p>
            <p>
              <br>2.2.4 Для принятия, отмены, корректировки, подтверждения выполнения заказа Служба Доставки использует соответствующие кнопки.
            </p>
            <p>
              <br>3. Права Сторон
            </p>
            <p>
              <br>3.1. Служба Доставки вправе участвовать в проводимых Сервисом акциях, предлагая потребителям скидки, бонусы, участие в акциях, предоставляя потребителям скидку на день рождения. Служба Доставки вправе стать инициатором предоставления бонусов, льгот, подарков и согласовывает данные предложения с Сервисом, вправе размещать акции, рецепты, новости во всех группах Сервиса в социальных сетях путем предложения  новостей в официальных группах.
            </p>
            <p>
              <br>3.2. Сервис вправе расторгнуть договор Оферты в одностороннем порядке без уведомления сторон при отказах Службой Доставки от заказов более 10 раз в месяц.
            </p>
            <p>
              <br>3.3. Сервис вправе воспроизводить на сайте и в рекламе торговые марки и иные обозначения, а также объекты, воспроизводимые при помощи фотографий, графики, которые в личном кабинете были загружены Службой Доставки.
            </p>
            <p>
              <br>3.4. Служба Доставки не оплачивает вознаграждение Сервису в случае, если Потребитель отказался от получения заказы и его оплаты по собственной инициативе и такой заказ отмечается как «Не участвующий в расчетах».
            </p>
            <p>
              <br>4. Финансовые взаимоотношения Сторон
            </p>
            <p>
              <br>4.1. Служба Доставки самостоятельно определяет способы получения оплаты от потребителя. Служба Доставки вправе принимать оплату любым законным способом. При согласии принимать онлайн оплату Служба Доставки выплачивает банку-эквайеру комиссию до 3,2 (три целых две десятых) %, которая автоматически удерживается им при произведении перечисления денежных средств.
            </p>
            <p>
              <br>4.2 Стороны согласовали что Сервис получает вознаграждение в размере 10% от суммы всех заказов, поступивших и доставленных Потребителю через сайт www.хочу-поесть.рф, независимо от способа их оплаты. Количество обработанных заказов и размер вознаграждения отражаются в личном кабинете Службы Доставки и личном кабинете Сервиса и являются основанием для выставления счета.
            </p>
            <p>
              <br>4.3. Не позднее 3 числа каждого месяца Сервис составляет акт сверки за предыдущий календарный месяц. Акт сверки направляется Службе доставки по электронной почте и в личном кабинете. При отсутствии подписанного акта сверки со стороны Службы доставки и отсутствия возражений по количеству заказов и сумме, акт считает подписанным на третий рабочий день с момента направления акта сверки на электронную почту/ в личном кабинете Службы доставки. В акте сверки в том числе учитываются возвраты денежных средств Потребителю.
            </p>
            <p>
              <br>4.4 Служба Доставки  выплачивает вознаграждение Сервису один раз в месяц не позднее 10 (десятого) числа текущего месяца за предыдущий на основании выставленного счёта.
            </p>
            <p>
              <br>4.5  В случае, если заказ не был принят или не обработан должным образом по вине Службы Доставки, в том числе, ввиду просрочки принятия заказа в личном кабинете и осуществления звонка Потребителю, осуществившему заказ, такой заказ считается принятым и Служба Доставки также осуществляет за него соответствующую выплату.
            </p>
            <p>
              <br>4.6. При согласии Службы доставки на оплату части Заказа бонусными рублями (баллами), Служба Доставки освобождается от выплаты суммы и начисления вознаграждения на сумму бонусных рублей, учтенных в каждом заказе.
            </p>
            <p>
              <br>5. Срок действия порядок расторжения договора
            </p>
            <p>
              <br>5.1 Договор вступает в силу с момента Акцепта Оферты «Службой доставки» и действует до момента расторжения Договора.
            </p>
            <p>
              <br>6. Ответственность Сторон
            </p>
            <p>
              <br>6.1 Служба Доставки несет единоличную ответственность за соблюдение норм и требований действующего Законодательства при производстве продуктов питания и готовых блюд, а также за их доставку и единолично отвечает перед потребителем при нарушении их прав, самостоятельно регулирует вопросы замены товара, возврата денежных средств.
            </p>
            <p>
              <br>7. Акцепт Оферты и заключение Договора
            </p>
            <p>
              <br>7.1. «Служба доставки» производит Акцепт Оферты путем последовательного совершения следующих действий:
            </p>
            <p>
              <br>7.1.1. Нажатие на кнопку «Полностью ознакомился и согласен с условиями Оферты» (или аналогичной по смыслу) на интернет-ресурсе www.хочу-поесть.рф или подписание анкеты или иного документа, указывающего на ознакомление с Офертой.
            </p>
            <p>
              <br>7.2. Разрешение споров осуществляется в соответствии с действующим законодательством
            </p>
            <p>
              <br>7.3. Настоящая Оферта и все дополнения к Оферте являются официальными документами и публикуются
            </p>
            <p>
              <br>8. Реквизиты сторон
            </p>
            <p>
              <br>Сервис: Общество с ограниченной ответственностью «Франшиз девелопмент рус»
            </p>
            <p>
              <br>Юр/факт адрес: г. Москва, ул. Автозаводская, 23 а корпус 2
            </p>
            <p>
              <br>Почтовый адрес: г. Москва, Севастопольский пр-т, 11/1, 117152, тел\факс (495) 120-13-68
            </p>
            <p>
              <br>t@hochu-poest.com , ОГРН 1107746558743, ИНН 7725698667, КПП 772501001
            </p>
            <p>
              <br>АО «Альфа Банк» БИК 044525593 , р\сч 40702810702370002426
            </p>
            <p>
              <br>Е.В.Шельмин_________________________
            </p>
            <br>
            <p>
              <br>
            </p>
          </div>
        </div>

        <div class="info_agreement">
          <input type="checkbox" name="" id="oferta" v-model="oferta">
          <label for="oferta">
            Полностью ознакомился и согласен с условиями Оферты
          </label>
        </div>
        <button class="menu_item_btn" @click="sendOferta">Подтвердить</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'oferta',
  data () {
    return {
      oferta: false
    }
  },
  methods: {
    sendOferta () {
      if (!this.oferta) alert('Вам необходимо согласиться с условиями')
      else this.$router.push({name: 'forRestaurants'})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/articles/oferta.vue